import Grid from '@mui/material/Grid';
import { RHFAutoComplete } from '@openx/components-core/lib/AutoComplete/RHFAutoComplete';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SectionTitle } from '../components/SectionTitle';
import { getLeanFilters, SupplementalAdQualityField } from '../constants';

export function LeanFiltersSection() {
  const { t } = useTranslation();
  const options = useMemo(() => getLeanFilters(t), [t]);

  return (
    <>
      <SectionTitle title={t('Request Limit')} />
      <Grid container spacing={1}>
        <Grid size={6}>
          <RHFAutoComplete
            name={SupplementalAdQualityField.REQUEST_LIMIT}
            textFieldProps={{ margin: 'dense' }}
            disableClearable={true}
            getOptionLabel={option => options[option]?.name || option}
            options={Object.keys(options)}
            fullWidth
            data-test="saq-request"
          />
        </Grid>
      </Grid>
      <SectionTitle title={t('File Weight')} />
      <Grid container spacing={1}>
        <Grid size={6}>
          <RHFAutoComplete
            name={SupplementalAdQualityField.FILE_WEIGHT}
            textFieldProps={{ margin: 'dense' }}
            disableClearable={true}
            getOptionLabel={option => options[option]?.name || option}
            options={Object.keys(options)}
            fullWidth
            data-test="saq-file"
          />
        </Grid>
      </Grid>
    </>
  );
}
